import { Organization } from './organization';

/**
 * Where an MCP client's access ends up: a web app (`host` is its host), an app
 * opened through its own link scheme (`host` is the scheme) or an app on the
 * user's computer (no host).
 */
export type McpDestinationKind = 'web' | 'app' | 'computer';

/**
 * What the Sytex MCP server sealed into an MCP login: the client asking, where
 * its access goes and the Sytex instance the user chose. The /cli page shows
 * this instead of anything from its link, which anyone can rewrite.
 */
export class McpClientRequest {
  readonly clientName: string;
  readonly isClientVerified: boolean;
  /**
   * The host serving the client's metadata document: who it is when Sytex did
   * not verify it, since its name is whatever it chose to call itself. Null for
   * a client that registered itself, which has no host.
   */
  readonly clientHost: string | null;
  readonly destinationKind: McpDestinationKind;
  readonly destinationHost: string | null;
  readonly instanceHost: string;

  constructor({
    clientName,
    isClientVerified,
    clientHost,
    destinationKind,
    destinationHost,
    instanceHost
  }: McpClientRequestData) {
    this.clientName = clientName;
    this.isClientVerified = isClientVerified;
    this.clientHost = clientHost;
    this.destinationKind = destinationKind;
    this.destinationHost = destinationHost;
    this.instanceHost = instanceHost;
  }

  /** The server answers a callback only from the instance the user chose there. */
  isOnInstance(organization: Organization): boolean {
    return organization.url.host === this.instanceHost;
  }
}

export interface McpClientRequestData {
  clientName: string;
  isClientVerified: boolean;
  clientHost: string | null;
  destinationKind: McpDestinationKind;
  destinationHost: string | null;
  instanceHost: string;
}
